module.exports = __webpack_public_path__ + "img/bg-uuva-cloud.cdf54950.jpg";